export const appId = 'com.brightcns.h5'
export const signType = 'NA'
export const sign = ''
export const version = '1.0'
export const sessionId = ''
// 后台系统ID
export const sysId = '1'

